import {UserAdsError} from './UserAdsError.js'

export class RenewUserAdsError extends UserAdsError {
  #message
  static create({message}) {
    return new RenewUserAdsError({message})
  }

  constructor({message}) {
    super()
    this.#message = message
  }

  toJSON() {
    return {message: this.#message}
  }
}
